import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useOverview(range) {
  return useQuery({
    queryKey: ["overview", range],
    queryFn: async () => (await api.get(`/dashboard/overview?range=${range}`)).data,
  });
}
